// This file was converted from JS to TS and therefore, has per-line allowances for "any" types. Please do
// not add additional "any" types and please update any "any" types to the correct type if you are updating
// existing code

import classNames from 'classnames';
import createReactClass from 'create-react-class';
import produce from 'immer';
import reactUpdate, {Spec} from 'immutability-helper';
import $ from 'jquery';
import React, {ReactNode} from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import {assert} from 'Asserts';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import {getLocationOrigin, kv} from 'BenchlingUtil';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as DataTableUtil from 'notebook/data-tables/DataTableUtil';
import {IndexSlice, Selector} from 'notebook/ELNConstants';
import MediocrePlugins from 'notebook/mediocre/base-plugin/plugins';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import {WYCIWYPPart} from 'notebook/mediocre/clipboard/WyciwypConstants';
import augmentNoteParts, {AugmentNotePartsContext} from 'notebook/mediocre/core-ui/augmentNoteParts';
import MediocreItem from 'notebook/mediocre/core-ui/MediocreItem';
import convertStructuredTableForPaste, {
  StructuredTablePasteError,
} from 'notebook/mediocre/core-ui/structured-tables/convertStructuredTableForPaste';
import {VirtualizedList} from 'notebook/mediocre/core-ui/Virtualization';
import {
  EditorProps,
  MediocreItemAction,
  MediocreItemEditor,
  MediocreSelection,
  PasteEvent,
  PendingCut,
} from 'notebook/mediocre/EditorTypes';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import FormattersConstants, {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import * as MediocreConstants from 'notebook/mediocre/MediocreConstants';
import CtrlFInput from 'notebook/mediocre/search/CtrlFInput';
import {getSearchResultPropsForIndex} from 'notebook/mediocre/search/SearchResultProps';
import {MediocreSearchState} from 'notebook/mediocre/search/useCtrlF';
// @ts-expect-error legacy JS module without declarations
import MultiSelectLinearList from 'notebook/mediocre/selection/block/MultiSelectLinearListMixin';
import {MetadataForRestore} from 'notebook/mediocre/selection/block/MultiSelectListUtil';
import {BenchlingSelection, SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import {EditorPropertiesContextInterface} from 'notebook/notes/core-ui/NoteContext';
import {makeDefaultItem} from 'notebook/notes/CreateOps';
import {MAX_INDENTATION} from 'notebook/notes/lists/ListConstants';
import NoteConstants, {PRINT_OPTION} from 'notebook/notes/NoteConstants';
import {NoteEditorPlugin, NoteEditorProps} from 'notebook/notes/NoteEditorTypes';
import {
  resolveSelectorsFromPastedHTMLTables,
  resolveSelectorsFromPastedItems,
} from 'notebook/plain-tables/selectors/SelectorConflictResolver';
import {StructuredTableInsertionContextValue} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {generatePlainTableProvenanceUuid} from 'notebook/tables/augmentNotePartTablesWithValues';
import {Cell, PastedCell} from 'notebook/tables/constants/CellConstants';
import {FocusedTableViewMode, Table} from 'notebook/tables/constants/TableConstants';
import {TableIndex} from 'notebook/tables/constants/TableSelectionConstants';
import excess from 'notebook/tables/excess';
import FormulaUtil from 'notebook/tables/excess/FormulaUtil';
import {
  MultidocTableOpMap,
  TableOpDiffMap,
  TableOpFunction,
  TableOpOptions,
} from 'notebook/tables/excess/ops/TableOpConstants';
import sanitizeCell from 'notebook/tables/paste/sanitizeCell';
import {isNoteFillInTextBox} from 'notebook/TypePredicates';
import {FileAnalyticsParams} from 'notebook/util/analytics/FileAnalyticsUtils';
import {generateUniqueName} from 'notebook/util/GenerateUniqueName';
import {
  AnyStructuredTable,
  Note,
  NoteLinkedObjectType,
  NotePart,
  isNotePartWithItem,
} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import * as Perf from 'performance/Perf';
import DocumentEditorLockUtil from 'realtime/util/DocumentEditorLockUtil';
import {NoteLinkedAssayData} from 'runs/AttachmentConstants';
import * as NoteLinkedAssayDataUtil from 'runs/NoteLinkedAssayDataUtil';
import APIUtil from 'util/APIUtil';
import * as keyboard from 'util/Keyboard';
import * as logging from 'util/Logging';
import {omit} from 'util/omitKey';
import {BasicEvent, ElementClipboardEvent, ElementKeyboardEvent, Optional} from 'util/Types';

import convertNoteLinkedGroupForPaste from './note-linked-groups/convertNoteLinkedGroupForPaste';
import {PendingCutOverlay} from './PendingCutOverlay';
import {
  buildPendingCutsFromItems,
  doesClipboardMatchPendingCuts,
  extractFileIdsFromClipboard,
  findNotePartsForPendingCuts,
  isPendingCut,
} from './pendingCutUtils';

const {TYPING_PERF_INTERVAL} = MediocreConstants;

const DEFAULT_INDEX_SLICE = {start: -Infinity, end: Infinity};

interface PasteRangeParams {
  start: number;
  end: number;
  replacement?: NotePart;
  after?: {text: string; formats: Format};
  originalEvent: ElementClipboardEvent;
}

export interface InternalEditorProps extends NoteEditorProps {
  note: Note;
  fileType?: ModelTypeConstants | null;
  editorKey: string;
  getItems: (root: Note) => Array<NotePart>;
  getRoot: () => Note;
  getType: (item: NotePart) => string;
  findIndexForTableProvenanceUuid?: (root: Note, uuid: string) => number;
  updateRoot: (
    root: Note,
    options?: {
      performTableEvaluation?: boolean;
      updatedItemPartIndexes?: Array<number>;
      canIncrementalSave?: boolean;
      multidocTableOp?: MultidocTableOpMap;
    }
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsAccessor: (update: any) => any;
  selectorCounts?: Record<string, number>;
  isConfig?: boolean;
  undoState: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  redoState: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  printOptions?: Array<PRINT_OPTION>;
  printHandler?: (format: PRINT_OPTION, indexSlice?: IndexSlice | null) => void;
  focusedTableProvenanceUuid?: string | null;
  banner?: React.ReactNode;
  focusedTableViewMode?: string;
  undoStoreState: () => void;
  structuredTableInsertionContext?: StructuredTableInsertionContextValue;
  permissions: Permissions;
  disableSplitscreen?: boolean;
  editorPropertiesContext?: EditorPropertiesContextInterface;
}

export interface IndexRange {
  start: number;
  end: number;
}

interface EditorPerformance {
  summaryByType: Record<
    string,
    {
      count: number;
      size: number;
    }
  >;
}

interface EditorMixinState {
  editorProps: EditorProps<NotePart>;
  focusedTableProvenanceUuid: string | null;
  focusedTableViewMode: string;
  searchState?: MediocreSearchState;
  atSignState?: {
    query: string;
    hidden?: boolean;
  } | null;
  selected?: {
    index?: number;
    subIndex?: string;
    hasNonEmptyTextSelection?: boolean;
  };
  highlightIndex?: number;
  insertIndex?: number;
  pendingCuts: Array<PendingCut>;
}

interface MultiSelectMouseDownOptions {
  start: number;
  active: boolean;
  allowSingleOverride: boolean;
  isMultiExpandBuffered: boolean;
}

/** Document-complexity metrics merged into typing performance telemetry. */
export type ExtraTypingPerfMetadata = Record<string, number | null | undefined>;

export interface EditorMixinInterfaceBase {
  registeredPlugins: Record<string, NoteEditorPlugin>;
  setText: (type: string, content: {text: string; formats: Format}) => Spec<NotePart>;
  getText: (item: NotePart) => {text: string; formats: Format};
  getPluginByType: (type: string) => NoteEditorPlugin;
  getPluginByItem: (item: NotePart) => NoteEditorPlugin;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItemProps: (item: NotePart, index: number) => Record<string, any>;
  itemFromHTML: ($el: JQuery, fileAnalyticsParams: FileAnalyticsParams) => NotePart;
  itemToHTML: (item: NotePart, jsonSourceItem?: NotePart) => JQuery;
  withUpdatedText: (item: NotePart, content: {text: string; formats: Format}) => NotePart;
  updateItemText: (index: number | string, content: {text: string; formats: Format}) => void;
  replaceItemsDefault: (index: number, deleteCount: number, ...items: Array<NotePart>) => boolean;
  replaceItemsForAtomicMoveDefault: (
    cutStart: number,
    cutCount: number,
    pasteStart: number,
    pasteDeleteCount: number,
    addedItems: Array<NotePart>
  ) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSelectors: () => Array<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _resolveSelectorsFromPastedItems: (items: Array<NotePart>, $items: JQuery) => Promise<any>;
  parseItemsFromClipboard: (
    e: ElementClipboardEvent,
    fileAnalyticsParams: FileAnalyticsParams
  ) => Promise<{
    items?: Array<NotePart>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectors?: Array<any>;
  }>;
  processItemsForHTMLClipboard: (items: Array<NotePart>, jsonSourceItems?: Array<NotePart>) => string;
  processItemsForTextClipboard: (items: Array<NotePart>) => string;
  makeEditorPropsBase: (props: Partial<InternalEditorProps>) => Partial<InternalEditorProps>;
  restoreStateAndClearPendingCuts: (
    e: ElementKeyboardEvent,
    selectionRestoreData: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData}
  ) => boolean;
  performTableOpAndClearPendingCuts: (tableOperation: {
    tableName: string;
    op: TableOpFunction;
    options?: TableOpOptions;
  }) => void;
  undoStateAndClearPendingCuts: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  redoStateAndClearPendingCuts: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  getFocusedItemOrNull: () => {item: NotePart; index: number} | null;
  renderFocusedTable: () => ReactNode;
  setMaximizedTable: (uuid: string | null, viewMode?: string) => void;
  setSplitScreenTable: (uuid: string | null, viewMode?: string) => void;
  _getProvenanceUuidForTable: (table: NotePart) => string | undefined;
  isTableFocused: (table: NotePart) => boolean;
  allowSplitScreen: () => boolean;
  shouldRenderMaximizedTable: () => boolean;
  shouldRenderSplitScreenTable: () => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _getTypingPerfMetadata: () => Record<string, any>;
  isReplaceItemsAllowedOrWarn: (index: number, deleteCount: number, ...items: Array<NotePart>) => boolean;
  getReasonForDisallowedAction: (item: NotePart, action: string) => string | null | undefined;
  selectionInit: (item: NotePart) => {selection: BenchlingSelection};
  selectionAtStart: (item: NotePart) => {selection: BenchlingSelection};
  selectionAtEnd: (item: NotePart) => {selection: BenchlingSelection};
  selectionAtItem: (item: NotePart | null) => MetadataForRestore<TableIndex> | null;
  selectionAll: (item: NotePart) => {selection: BenchlingSelection};
  hasSelectionAll: (item: NotePart) => boolean;
  setSelectionAbove: (index: number) => void;
  setSelectionBelow: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createDefaultableItem: (type: string, content?: any) => NotePart;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItemWithUpdatedContent: (item: NotePart, content: any) => NotePart;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertDefaultableItemHandler: (index: number, type: string, content?: any) => void;
  itemInsertHandler: (index: number, ...newItems: Array<NotePart>) => void;
  copyItemWithoutText: (index: number, e: ClipboardEvent) => void;
  copyItem: (index: number, e: ClipboardEvent) => void;
  itemDeleteHandler: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _itemUpdateHelper: (index: number, content: any) => Note;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemUpdateHandler: (index: number, content: any) => void;
  tableUpdateHandler: (
    index: number,
    content: NotePart & {table: Table},
    selectors: Array<Selector> | null
  ) => void;
  itemMouseOverHandler: (index: number, e: React.MouseEvent) => void;
  itemMouseMoveHandler: (index: number, e: React.MouseEvent) => void;
  itemMouseDownHandler: (index: number, e: React.MouseEvent) => void;
  textItemUpdateHandler: (
    index: number,
    e: {selection?: BenchlingSelection; text?: string; formats?: Format}
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textItemMergeUpHandler: (index: number, e: {anchor: any}) => void;
  pasteHandler: (index: number, e: PasteEvent, fileAnalyticsParams: FileAnalyticsParams) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatRangeHandler: (params: {start: number; end: number; format: string; data: any}) => void;
  deleteRangeHandlerDefault: (params: {start: number; end: number}) => void;
  inputRangeHandler: (params: {start: number; end: number; text: string}) => void;
  convertWyciwypPartsToItems: (
    clipboardData: DataTransfer
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<{items: Array<NotePart>; selectors: any}>;
  convertItemForPaste: (
    item: NotePart,
    destinationFileId: string,
    usedTableNames?: Array<string>,
    usedTextBoxNames?: Array<string>,
    isDestinationConfig?: boolean
  ) => {addedItem: NotePart; oldName: string; newName: string};
  _augmentNoteParts: (noteParts: Array<NotePart>) => Array<NotePart>;
  getTextBoxNames: () => Array<string>;
  convertItemsForPaste: (
    items: Array<NotePart>,
    destinationFileId: string,
    usedTableNames?: Array<string>,
    isDestinationConfig?: boolean
  ) => {items: Array<NotePart>; names: Array<string>};
  pasteRangeHandler: (
    params: {
      start: number;
      end: number;
      replacement?: NotePart;
      after?: {text: string; formats: Format};
      originalEvent: BasicEvent;
    },
    fileAnalyticsParams: FileAnalyticsParams
  ) => void;
  _getIndentationOfItemFromBase: (baseItem: NotePart | null, newItem: NotePart | null) => number;
  renderEditable: (item: NotePart, index: number) => ReactNode;
  getRenderedItems: (items: Array<NotePart>, indexSlice?: IndexRange) => Array<ReactNode>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setSearchState: (searchState: any) => void;
  isVirtualizationEnabled: () => boolean;
  renderEditor: (indexSlice: IndexRange | null) => ReactNode;
  atIndex: (index: number) => NotePart;
  setContent?: Function;
  tableType: string;
  _isMounted: boolean;
  _setPendingCuts: (cuts: Array<PendingCut>) => void;
  _clearPendingCuts: () => void;
  _buildAddedItemsForPaste: (
    itemsToAdd: Array<NotePart>,
    replacement: NotePart | undefined,
    after?: {text: string; formats: Format}
  ) => {addedItems: Array<NotePart>; selectedItem: NotePart | null; selection: MediocreSelection | null};
  _shouldPerformAtomicMove: (params: PasteRangeParams) => boolean;
  _performAtomicMove: (params: PasteRangeParams) => void;
  typingPerfId: Perf.PerfId;
  notePerformance?: EditorPerformance;
  editorName: () => string;
  makeEditorProps: (props: Partial<InternalEditorProps>) => EditorProps<NotePart>;
  parseItemsFromFile: (file: Blob) => Promise<{
    items?: Array<NotePart>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectors?: Array<any>;
  }>;
  defaultInsertType: string;
  onSetFocusedTable: (uuid: string | null, viewMode: string) => void;
  getExtraTypingPerfMetadata: () => ExtraTypingPerfMetadata;
  computeState: (params: {
    multiStartIndex: number;
    multiEndIndex: number;
    multiSelIndex: number;
  }) => MetadataForRestore<TableIndex>;
  lastIndex: () => number;
  replaceItems: (index: number, deleteCount: number, ...items: Array<NotePart>) => boolean;
  replaceItemsForAtomicMove: (
    cutStart: number,
    cutCount: number,
    pasteStart: number,
    pasteDeleteCount: number,
    addedItems: Array<NotePart>
  ) => boolean;
  clearMultiSelect: () => void;
  headerType: string;
  descType: string;
  textType: string;
  withUpdatedListStyle?: (
    item: NotePart,
    options: {
      indentation: number;
      listType?: string | null;
    }
  ) => NotePart;
  makeItemFromWyciwypPart?: (
    part: WYCIWYPPart,
    usedTableNames: Array<string>
  ) => {
    item: NotePart;
  };
  makeItem: (type: string) => NotePart;
  itemHasText: (item: NotePart) => boolean;
  requiresTableEvaluationOnUpdate: (item: NotePart) => boolean;
  multiEditableMouseOverHandler: (index: number, e: React.MouseEvent) => void;
  isItemTextual: (item: NotePart) => boolean;
  subList: (start: number, end: number) => Array<NotePart>;
  saveMultiSelect: () => void;
  canItemHaveHeader: (item: NotePart) => boolean;
  headerTypeAccessor: (op: {$set: string}) => Spec<NotePart, never>;
  postProcessRenderedItems?: (indexSlice: IndexRange, items: Array<ReactNode>) => Array<ReactNode>;
  setSelection: (selection: {start: number; end: number}) => void;
  isVirtualizationSupported: () => boolean;
  renderFocusBearer: () => ReactNode;
  getDocumentVersionCid: () => string;
  multiEditableMouseMoveHandler: (index: number, e: React.MouseEvent) => void;
  multiEditableMouseDownHandler: (options: MultiSelectMouseDownOptions, e: React.MouseEvent) => void;
  getHeaderType(item: NotePart): string | null;
  getListType(item: NotePart): string | null;
  getIndentation(item: NotePart): number;
  isSelected(index: number): boolean;
  getSearchableItems(root: Note): Array<NotePart>;
  /*
   * This is stored on the class itself, not on React state, in order to avoid spurious and expensive
   * rerenders of structured tables and other notebook content.
   */
  editor: HTMLDivElement | null;
  setEditorRef(editor: HTMLDivElement | null): void;
  getEditorRef(): HTMLDivElement | null;
}

export interface EditorMixinInterface
  extends EditorMixinInterfaceBase, React.Component<InternalEditorProps, EditorMixinState> {
  getInitialState: () => EditorMixinState;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EditorMultiEditableMixin: any = {
  previousIndex(index: number): number {
    return Math.max(index - 1, this.firstIndex());
  },

  nextIndex(index: number): number {
    return Math.min(index + 1, this.lastIndex());
  },

  firstIndex(): number {
    return 0;
  },

  lastIndex(): number {
    return this.props!.getItems(this.props!.getRoot()).length - 1;
  },

  /**
   * Return the index of the item with the given cid, or -1 if is not found.
   */
  getIndex(cid: string): number {
    const items = this.props!.getItems(this.props!.getRoot());
    return items.findIndex((item: {cid: string}) => item.cid === cid);
  },

  /**
   * Return the item at the given index, or undefined if out of bounds.
   */
  atIndex(index: number): NotePart {
    const items = this.props!.getItems(this.props!.getRoot());
    return items[index];
  },

  // Start and end are inclusive to match the multi-select range.
  subList(start: number, end: number): Array<NotePart> {
    const items = this.props!.getItems(this.props!.getRoot());
    return items.slice(start, end + 1);
  },

  compareIndex(a: number, b: number): number {
    return a - b;
  },

  multiGetHTMLForCopy() {
    const {start, end} = this.sortedMultiRange();
    return this.processItemsForHTMLClipboard(this.subList(start, end));
  },

  multiGetTextForCopy() {
    const {start, end} = this.sortedMultiRange();
    return this.processItemsForTextClipboard(this.subList(start, end));
  },
};

const EditorMixin: Partial<EditorMixinInterface> & ThisType<EditorMixinInterface> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setText(type: any, {text, formats}: {text: any; formats: Format}): Spec<NotePart> {
    const plugin = this.getPluginByType(type);
    return plugin.setText!.call(this, {text, formats});
  },

  getText(item: NotePart) {
    const type = this.props.getType(item);
    const plugin = this.getPluginByType(type);
    return plugin.getText!.call(this, item);
  },

  // Internal helper methods
  getPluginByType(type: string | number) {
    if (!this.registeredPlugins[type]) {
      throw new Error(`Unexpected plugin type: ${type}`);
    }
    return this.registeredPlugins[type];
  },

  getPluginByItem(item: NotePart) {
    return this.getPluginByType(this.props.getType(item));
  },

  getItemProps(item: NotePart, index: number) {
    return this.getPluginByItem(item).component.getItemProps?.call(this, item, index) ?? undefined;
  },

  itemFromHTML($el: JQuery, fileAnalyticsParams: FileAnalyticsParams) {
    const item = JSON.parse($el.attr('data-mediocre-item'));
    item.cid = _.uniqueId('item');
    const plugin = this.getPluginByItem(item);
    const itemOrigin = $el.attr('data-origin'); // undefined if copied from old client
    if (!plugin.canPasteFromOtherTenant && itemOrigin && itemOrigin !== getLocationOrigin()) {
      notifications.warn(`Some items could not be pasted from ${itemOrigin} and were skipped.`, {
        id: 'mediocre-cross-tenant-paste',
      });
      logging.info('User tried to paste content from a different Benchling tenant', {
        extra: {
          pluginType: plugin.type,
          itemOrigin,
          currentOrigin: getLocationOrigin(),
        },
      });
      return null;
    }

    return plugin.itemFromHTML.call(this, $el, item, fileAnalyticsParams);
  },

  itemToHTML(item: NotePart, jsonSourceItem?: NotePart) {
    const plugin = this.getPluginByItem(item);
    const itemForJson = jsonSourceItem ?? item;
    const $el = $('<div></div>').attr({
      'data-mediocre-item': JSON.stringify(omit(itemForJson, 'taskId', 'task')),
      'data-origin': getLocationOrigin(),
      'data-mediocre-editor': this.editorName(),
      'data-mediocre-file-id': this.props.fileId,
    });
    if (this.props.getType(item) === this.tableType) {
      $el.attr('data-selectors', JSON.stringify(this.getSelectors()));
    }
    return plugin.itemToHTML.call(this, $el, item);
  },

  // Internal update helpers
  withUpdatedText(item: NotePart, {text, formats}: {text: string; formats: Format}) {
    const type = this.props.getType(item);
    return reactUpdate(item, this.setText(type, {text, formats}));
  },

  updateItemText(index: number, {text, formats}: {text: string; formats: Format}) {
    this._clearPendingCuts();
    const type = this.props.getType(this.atIndex(index));
    const root = reactUpdate(
      this.props.getRoot(),
      this.props.itemsAccessor(kv(index, this.setText(type, {text, formats})))
    );
    this.props.updateRoot?.(root, {
      performTableEvaluation: false,
      updatedItemPartIndexes: [index],
      canIncrementalSave: true,
    });
  },

  replaceItemsDefault(index: number, deleteCount: number, ...items: Array<NotePart>) {
    this._clearPendingCuts();

    if (!this.isReplaceItemsAllowedOrWarn(index, deleteCount, ...items)) {
      return false;
    }

    const root = reactUpdate(
      this.props.getRoot(),
      this.props.itemsAccessor({$splice: [[index, deleteCount, ...items]]})
    );
    this.props.updateRoot?.(root);
    return true;
  },

  replaceItemsForAtomicMoveDefault(
    cutStart: number,
    cutCount: number,
    pasteStart: number,
    pasteDeleteCount: number,
    addedItems: Array<NotePart>
  ): boolean {
    if (!this.isReplaceItemsAllowedOrWarn(pasteStart, pasteDeleteCount, ...addedItems)) {
      return false;
    }
    this._clearPendingCuts();

    let root = reactUpdate(this.props.getRoot(), this.props.itemsAccessor({$splice: [[cutStart, cutCount]]}));
    const adjustedPasteStart = cutStart < pasteStart ? pasteStart - cutCount : pasteStart;
    root = reactUpdate(
      root,
      this.props.itemsAccessor({$splice: [[adjustedPasteStart, pasteDeleteCount, ...addedItems]]})
    );
    this.props.updateRoot?.(root);
    return true;
  },

  getSelectors() {
    return this.props.getRoot().selectors;
  },

  async _resolveSelectorsFromPastedItems(
    items: Array<NotePart>,
    $items: Iterable<unknown> | ArrayLike<unknown>
  ) {
    const pastedTables = items
      .filter((item: NotePart) => item.type === this.tableType) // Why is this against an Editor class variable tableType?
      .map((item: NotePart) => item.table!.table);
    // Deserialize selectors that were serialized via processItemsForHTMLClipboard
    const pastedSelectors = _.chain(Array.from($items))
      .filter((item: string) => $(item).is('[data-selectors]'))
      .map((item: string) => JSON.parse($(item).attr('data-selectors')))
      .flatten()
      .uniq((selector) => selector.staticId)
      .value();
    return await resolveSelectorsFromPastedItems({
      pastedTables,
      pastedSelectors,
      existingSelectors: this.getSelectors(),
    });
  },

  /**
   * Given a paste event, returns a Promise that resolves with a list of items that were processed from the
   * clipboard. If no data could be found on the clipboard, resolves with null.
   *
   * Note: The caller should /not/ access e.clipboardData in the Promise's then handler, as the browser will
   * mutate the event and clear clipboardData.
   *
   * @param  {Event} e
   * @return {Promise<Partial<{items: Array<Item>, selectors: Array<Selector>}}
   */
  async parseItemsFromClipboard(
    e: ElementClipboardEvent,
    fileAnalyticsParams: FileAnalyticsParams
  ): Promise<{
    items?: Array<NotePart>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectors?: Array<any>;
  }> {
    // Prefer Benchling "text/html" that contains structured medicore data above all else.
    const hasHTML = wyciwyp.typesContains(e.clipboardData.types, 'text/html');
    if (hasHTML) {
      const html = wyciwyp.getHTMLData(e.clipboardData);

      // Safely parse html so that inline handlers (e.g. onload) don't run
      const $data = wyciwyp.jQuerySafeParseHTML(html);
      const itemSelector = `[data-mediocre-editor='${this.editorName()}']`;
      const $items = $data.find(itemSelector).addBack(itemSelector);
      if ($items.length) {
        e.preventDefault();
        const items = _.compact(
          Array.from($items).map((item) => this.itemFromHTML($(item), fileAnalyticsParams))
        );
        const selectors = await this._resolveSelectorsFromPastedItems(items, $items);
        const usedTableNames = this.props.usedTableNames?.() ?? [];
        const {items: convertedItems, names} = this.convertItemsForPaste(
          items,
          this.state.editorProps.fileId,
          usedTableNames,
          this.props.isConfig
        );
        usedTableNames.push(...names);
        return {items: convertedItems, selectors};
      }
    }

    const filePromise = wyciwyp.extractImageFromPaste(e);
    if (!filePromise) {
      // No file could be found, so we process the text/plain|text/html on the clipboard.
      e.preventDefault();
      return await this.convertWyciwypPartsToItems(e.clipboardData);
    }
    const file = await filePromise;
    if (!file) {
      return {};
    }
    return this.parseItemsFromFile(file);
  },

  // When jsonSourceItems is provided, the visual HTML is rendered from `items` (which may have
  // caption text stripped) while the data-mediocre-item JSON payload is serialized from
  // `jsonSourceItems` (preserving caption text). This allows Benchling-to-Benchling paste to
  // restore captions, while pasting into external apps produces clean HTML without caption spans.
  processItemsForHTMLClipboard(items: Array<NotePart>, jsonSourceItems?: Array<NotePart>) {
    this._clearPendingCuts();

    const elements = items.map((item, i) => this.itemToHTML(item, jsonSourceItems?.[i]).get(0));
    return $('<div>').append(elements).html();
  },

  processItemsForTextClipboard(items: Array<NotePart>) {
    return items
      .map((item: NotePart) => this.getPluginByItem(item).itemToText?.call(this, item))
      .filter((text: string | null) => text != null)
      .join('\n');
  },

  makeEditorPropsBase(props: Partial<InternalEditorProps>): Partial<InternalEditorProps> {
    return {
      fileId: props.fileId,
      locked: props.locked,
      storeState: props.storeState,
      restoreState: this.restoreStateAndClearPendingCuts,
      requestSelection: props.requestSelection,
      getCid: props.getCid,
      findIndexForTableProvenanceUuid: props.findIndexForTableProvenanceUuid,
      getProvenanceId: props.getProvenanceId,
      getContent: props.getContent,
      getSpreadsheetTableName: props.getSpreadsheetTableName,
      performTableOp: this.performTableOpAndClearPendingCuts,
      isTableNameUsed: props.isTableNameUsed,
      tryInsert: props.tryInsert,
      canInsert: props.canInsert,
      setContent: props.setContent,
      extraUsedTableNames: props.extraUsedTableNames,
      setMultiEditingForTable: props.setMultiEditingForTable,
      updateSelectors: props.updateSelectors,
      usedTableNames: props.usedTableNames,
      getType: props.getType,
      viewer: props.viewer,
      spreadsheetTypes: props.spreadsheetTypes,
      undoState: this.undoStateAndClearPendingCuts,
      setPendingCuts: this._setPendingCuts,
      clearPendingCuts: this._clearPendingCuts,
    };
  },

  restoreStateAndClearPendingCuts(
    e: ElementKeyboardEvent,
    selectionRestoreData: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData}
  ): boolean {
    this._clearPendingCuts();
    return this.props.restoreState?.(e, selectionRestoreData) ?? false;
  },

  performTableOpAndClearPendingCuts(tableOperation: {
    tableName: string;
    op: TableOpFunction;
    options?: TableOpOptions;
  }): void {
    this._clearPendingCuts();
    this.props.performTableOp?.(tableOperation);
  },

  undoStateAndClearPendingCuts(selectionRestoreData: {selection: SelectionRestoreData}): void {
    this._clearPendingCuts();
    this.props.undoState?.(selectionRestoreData);
  },

  redoStateAndClearPendingCuts(selectionRestoreData: {selection: SelectionRestoreData}): void {
    this._clearPendingCuts();
    this.props.redoState?.(selectionRestoreData);
  },

  _setPendingCuts(cuts: Array<PendingCut>) {
    DocumentEditorLockUtil.forceAcquireLocks(this.props.fileId);
    this.setState({pendingCuts: cuts});
  },

  _clearPendingCuts() {
    if (this.state.pendingCuts && this.state.pendingCuts.length > 0) {
      DocumentEditorLockUtil.clearReleaseLockTimeout(this.props.fileId);
      this.setState({pendingCuts: []});
    }
  },

  getInitialState() {
    return {
      editor: null,
      editorProps: this.makeEditorProps(this.props as InternalEditorProps),
      focusedTableProvenanceUuid: null,
      focusedTableViewMode: FocusedTableViewMode.FULLSCREEN,
      pendingCuts: [],
    };
  },

  UNSAFE_componentWillMount() {
    // Make sure all required methods are found.
    const requiredMethods = [
      'multiSelectKey',
      'makeItem',
      'isItemTextual',
      'itemHasText',
      'insertItemHandler',
      'editorName',
      'getDocumentVersionCid',
      'tableType',
      'textType',
      'headerType',
      'descType',
      'defaultInsertType',
      'parseItemsFromFile',
      'replaceItems',
      'deleteRangeHandler',
      'getHeaderType',
      'canItemHaveHeader',
      'headerTypeAccessor',
      'getExtraTypingPerfMetadata',
      'getComputedTables',
      'getValidationErrorSnapshot',
      'isVirtualizationSupported',
      // makeEditorProps should extend makeEditorPropsBase which returns any props from the editor that
      // needs to be accessed in a plugins' make method (via the editorProps parameter)
      'makeEditorProps',
    ];

    for (const method of requiredMethods) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((this as any)[method] == null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throw new Error(`${(this.constructor as any).displayName} requires method '${method}'.`);
      }
    }
    for (const type of Object.keys(this.registeredPlugins ?? {})) {
      const plugin = this.registeredPlugins[type];
      for (const method of Array.from(plugin.component.required)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any)[method] == null) {
          throw new Error(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            `${(this.constructor as any).displayName}'s plugin '${type}' requires method '${method}'.`
          );
        }
      }
    }

    this.typingPerfId = Perf.start(
      `${APIUtil.apiIdToType(this.props.fileId)}_editor_input`,
      {enabled: true, getMetadata: this._getTypingPerfMetadata},
      {
        interval: TYPING_PERF_INTERVAL,
        aggregations: [Perf.Aggregation.MEDIAN, Perf.Aggregation.MAX, Perf.Aggregation.COUNT],
      }
    );
  },

  componentDidMount() {
    this._isMounted = true;

    // If we receive a maximized table UUID as a prop, restore this saved state
    if (
      this.props.focusedTableProvenanceUuid != null &&
      this.props.focusedTableProvenanceUuid !== this.state.focusedTableProvenanceUuid &&
      this.props.findIndexForTableProvenanceUuid?.(
        this.props.getRoot(),
        this.props.focusedTableProvenanceUuid
      ) !== -1
    ) {
      this.setMaximizedTable(this.props.focusedTableProvenanceUuid, this.props.focusedTableViewMode);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  UNSAFE_componentWillReceiveProps(nextProps: any) {
    const newEditorProps = this.makeEditorProps(nextProps);
    if (!isEqual(newEditorProps, this.state.editorProps)) {
      this.setState({editorProps: newEditorProps});
    }
    // If the maximized table no longer exists, (e.g., User deletes it by undoing until before its
    // existence), unset maxmizedTableName
    if (
      this.state.focusedTableProvenanceUuid != null &&
      this.props.findIndexForTableProvenanceUuid?.(
        this.props.getRoot(),
        this.state.focusedTableProvenanceUuid
      ) === -1
    ) {
      this.setMaximizedTable(null);
    }
  },

  componentWillUnmount() {
    Perf.stop(this.typingPerfId);
    this._isMounted = false;
  },

  getFocusedItemOrNull() {
    if (!this.state.focusedTableProvenanceUuid) {
      return null;
    }

    const tableIndex = this.props.findIndexForTableProvenanceUuid?.(
      this.props.getRoot(),
      this.state.focusedTableProvenanceUuid
    );
    assert(tableIndex !== undefined && tableIndex >= 0, "Focused table doesn't exist in the note");
    const items = this.props.getItems(this.props.getRoot());
    return {item: items[tableIndex], index: tableIndex};
  },

  renderFocusedTable() {
    // Note: this method assumes that the component mixes in mediocre's EditorMixin; therefore,
    // it should not be called by `client/protocols/viewer/Procedure`.
    const value = this.getFocusedItemOrNull();
    assert(value != null, 'No focused table found');
    const {item: tableItem, index: tableIndex} = value;

    const type = this.props.getType(tableItem);
    const plugin = this.getPluginByType(type);
    const docRoot = this.props.getRoot();

    let itemComponent;
    // For tables, we want to render the component directly, rather than the plugin (which wraps it in a
    // caption and passes the props in through childProps rather than itemProps).
    // Ideally this would be a concern of the plugin, rather than the editor.
    if (type === NoteConstants.TABLE) {
      const itemProps = MediocrePlugins.getTableItemProps.call(this, tableItem);
      itemComponent = MediocrePlugins.makeTable.call(
        this,
        tableItem,
        tableIndex,
        this.state.editorProps,
        {
          ...itemProps,
          isFocused: false,
          isMaximized: this.state.focusedTableViewMode === FocusedTableViewMode.FULLSCREEN,
          isSplitScreen: this.state.focusedTableViewMode === FocusedTableViewMode.HORIZONTAL_SPLIT,
          banner: this.props.banner,
        },
        {...getSearchResultPropsForIndex(this.state.searchState, tableItem.cid)}
      );
    } else {
      const itemProps = this.getItemProps(tableItem, tableIndex);
      itemComponent = plugin.component.make.call(
        this,
        tableItem,
        tableIndex,
        this.state.editorProps,
        {
          ...itemProps,
          isFocused: false,
          isMaximized: this.state.focusedTableViewMode === FocusedTableViewMode.FULLSCREEN,
          isSplitScreen: this.state.focusedTableViewMode === FocusedTableViewMode.HORIZONTAL_SPLIT,
          banner: this.props.banner,
        },
        {...getSearchResultPropsForIndex(this.state.searchState, tableItem.cid)}
      );
    }
    return (
      <div key="maximized-table" className="tableEditable-maximizedWrapper">
        {this.isVirtualizationEnabled() &&
          this.state.focusedTableViewMode === FocusedTableViewMode.FULLSCREEN && (
            <CtrlFInput
              key="ctrl-f"
              docRoot={docRoot}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              editor={this as any}
              searchableItems={[]}
              focusedItem={tableItem}
              searchState={this.state.searchState}
              setSearchState={this.setSearchState}
              requestSelection={this.props.requestSelection}
            />
          )}
        {itemComponent}
      </div>
    );
  },

  setMaximizedTable(
    focusedTableProvenanceUuid: string | null,
    focusedTableViewMode: FocusedTableViewMode = FocusedTableViewMode.FULLSCREEN
  ) {
    if (
      this.state.focusedTableProvenanceUuid !== focusedTableProvenanceUuid ||
      this.state.focusedTableViewMode !== focusedTableViewMode
    ) {
      analytics.trackEvent(ELN_ANALYTICS_ACTIONS.CHANGED_TABLE_VIEW, {
        isMaximized: focusedTableProvenanceUuid != null,
        focusedTableViewMode,
      });
    }
    this.setState({focusedTableProvenanceUuid, focusedTableViewMode});
    if (typeof this.onSetFocusedTable === 'function') {
      this.onSetFocusedTable(focusedTableProvenanceUuid, focusedTableViewMode);
    }
  },

  setSplitScreenTable(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    focusedTableProvenanceUuid: any,
    focusedTableViewMode: FocusedTableViewMode = FocusedTableViewMode.HORIZONTAL_SPLIT
  ) {
    this.setMaximizedTable(focusedTableProvenanceUuid, focusedTableViewMode);
  },

  _getProvenanceUuidForTable(table: NotePart) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (table && table.item && (table.item as any).provenanceUuid) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (table.item as any).provenanceUuid;
    }
    if (table && !table.item && table.provenanceId) {
      return generatePlainTableProvenanceUuid(table.provenanceId);
    }
    return undefined;
  },

  isTableFocused(table: NotePart) {
    if (
      this.allowSplitScreen() &&
      this.state.focusedTableViewMode === FocusedTableViewMode.HORIZONTAL_SPLIT
    ) {
      return this._getProvenanceUuidForTable(table) === this.state.focusedTableProvenanceUuid;
    }
    return false;
  },

  allowSplitScreen() {
    return !this.props.viewer && !this.props.editorPropertiesContext?.disableSplitscreen;
  },

  shouldRenderMaximizedTable() {
    return (
      this.state.focusedTableProvenanceUuid != null &&
      this.state.focusedTableViewMode === FocusedTableViewMode.FULLSCREEN &&
      this.props.findIndexForTableProvenanceUuid?.(
        this.props.getRoot(),
        this.state.focusedTableProvenanceUuid
      ) !== -1
    );
  },

  shouldRenderSplitScreenTable() {
    return (
      this.allowSplitScreen() &&
      this.state.focusedTableProvenanceUuid != null &&
      this.state.focusedTableViewMode === FocusedTableViewMode.HORIZONTAL_SPLIT &&
      this.props.findIndexForTableProvenanceUuid?.(
        this.props.getRoot(),
        this.state.focusedTableProvenanceUuid
      ) !== -1
    );
  },

  _getTypingPerfMetadata() {
    return {
      file_id: this.props.fileId,
      ...this.getExtraTypingPerfMetadata(),
    };
  },

  /**
   * Show a warning to the user if replaceItems is to be cancelled.
   *
   * To be called within replaceItems implementation, indicating the intended return value for replaceItems.
   * Handles undoing a storeState that was just called. See implementation for more details.
   */
  isReplaceItemsAllowedOrWarn(index: number, deleteCount: number, ...items: Array<NotePart>) {
    const newCids = items.map((item) => this.props.getCid(item));
    const removedItems = this.props
      .getItems(this.props.getRoot())
      .slice(index, index + deleteCount)
      .filter((item: NotePart) => !newCids.includes(this.props.getCid(item)));
    for (const removedItem of removedItems) {
      const warning = this.getReasonForDisallowedAction(removedItem, MediocreItemAction.DELETE);
      if (warning) {
        // replaceItems' caller always calls "storeState" first, which adds a restore point in our history,
        // and often that happens higher up the callstack. Since we are not actually performing an edit, we
        // want to scrub this restore point from our history. Ideally we would avoid calling storeState
        // altogether, but since that is often higher up in the stack, where we don't have sufficient
        // context to determine if `replaceItems` will be cancelled yet. Note that `undoStoreState` will only
        // remove the restore point if it matches the current, unmodified document.
        this.props.undoStoreState?.();
        notifications.warn(warning, {id: 'mediocre-replace-items-blocked'});
        return false;
      }
    }
    return true;
  },

  // Convenience methods for commonly-used operations in editors.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getReasonForDisallowedAction(item: NotePart, action: any) {
    return this.getPluginByItem(item).getReasonForDisallowedAction?.call(this, item, action);
  },
  selectionInit(item: NotePart) {
    return this.getPluginByItem(item).component.selectionInit.call(this, item);
  },
  selectionAtStart(item: NotePart) {
    return this.getPluginByItem(item).component.selectionAtStart.call(this, item);
  },
  selectionAtEnd(item: NotePart) {
    return this.getPluginByItem(item).component.selectionAtEnd.call(this, item);
  },
  selectionAtItem(item: NotePart | null) {
    // Scan through all items in the editor to find the item's index
    const items = this.props.getItems(this.props.getRoot());
    const index = items.findIndex((anItem) => anItem.cid === item?.cid);
    if (index < 0) {
      // Log a warning, since this is unexpected, but avoid putting the cursor in a weird place.
      logging.info(`[BNCH-85564] Negative index being passed in for index selection : ${index}`);
      return null;
    }
    return this.computeState({multiStartIndex: index, multiEndIndex: index, multiSelIndex: index});
  },
  selectionAll(item: NotePart) {
    return this.getPluginByItem(item).component.selectionAll!.call(this, item);
  },
  hasSelectionAll(item: NotePart) {
    return this.getPluginByItem(item).component.selectionAll != null;
  },
  setSelectionAbove(index: number) {
    if (index === 0) {
      return;
    }
    const item = this.atIndex(index - 1);
    this.props.requestSelection?.(this.selectionAtEnd(item));
  },
  setSelectionBelow(index: number) {
    if (index === this.lastIndex()) {
      return;
    }
    const item = this.atIndex(index + 1);
    this.props.requestSelection?.(this.selectionAtStart(item));
  },

  createDefaultableItem(type: string, content: object | null = null) {
    const {component} = this.getPluginByType(type);
    if (content == null) {
      content = component.default!.call(this as EditorMixinInterfaceBase);
    }
    let newItem = this.makeItem(type);
    newItem = reactUpdate(newItem, this.props.setContent(type, content!));
    return newItem;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getItemWithUpdatedContent(item: NotePart, content: any) {
    const type = this.props.getType(item);
    return reactUpdate(item, this.props.setContent(type, content));
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertDefaultableItemHandler(index: number, type: any, content: any = null) {
    const newItem = this.createDefaultableItem(type, content);
    this.itemInsertHandler(index, newItem);
  },

  itemInsertHandler(index: number, ...newItems: Array<NotePart>) {
    // Indent inserted items from the indentation of the given index.
    newItems = newItems.map((newItem) => ({
      ...newItem,
      indentation: this._getIndentationOfItemFromBase(this.atIndex(index), newItem),
    }));
    newItems = this._augmentNoteParts(newItems);
    if (!this.replaceItems(index + 1, 0, ...newItems)) {
      return;
    }
    this.clearMultiSelect();
    const lastItem = newItems[newItems.length - 1];
    this.props.requestSelection?.(this.selectionInit(lastItem));

    let restoreSelection;
    if (index === -1) {
      // Hitting enter on first item inserts new first item.
      restoreSelection = this.selectionAtStart(this.atIndex(0));
    } else {
      const item = this.atIndex(index);
      assert(item != null, '[BNCH-6442] Item not found - is the index out of bounds?', {index});
      restoreSelection = this.selectionAtEnd(item);
    }

    this.props.storeState?.(restoreSelection);
  },

  copyItemWithoutText(index: number, e: ClipboardEvent): void {
    // Copies the item at the specified index. The visual HTML omits caption text (for pasting
    // into external apps), but the data-mediocre-item JSON preserves it (for Benchling-to-Benchling paste).
    const item = this.atIndex(index);
    let noTextItem = item;
    if (this.itemHasText(item)) {
      noTextItem = this.withUpdatedText(item, {text: '', formats: formatters.defaultFormats()});
    }
    if (e.clipboardData) {
      e.clipboardData.setData('text/html', this.processItemsForHTMLClipboard([noTextItem], [item]));
      e.clipboardData.setData('text/plain', this.processItemsForTextClipboard([noTextItem]));
    }
  },

  copyItem(index: number, e: ClipboardEvent) {
    const item = this.atIndex(index);
    if (e.clipboardData) {
      e.clipboardData.setData('text/html', this.processItemsForHTMLClipboard([item]));
      e.clipboardData.setData('text/plain', this.processItemsForTextClipboard([item]));
    }
  },

  itemDeleteHandler(index: number) {
    let item;
    let newItems: Array<NotePart>;
    let selection;
    this.props.storeState?.({selection: selutil.getSelectionIndices()!});
    if (index > 0) {
      // Deleting from the middle.
      item = this.atIndex(index - 1);
      selection = this.selectionAtEnd(item);
      newItems = [];
    } else if (this.lastIndex() >= 1) {
      // Deleting from the beginning, but not deleting everything.
      item = this.atIndex(1);
      selection = this.selectionAtStart(item);
      newItems = [];
    } else {
      // Deleting everything. Since there has to be at least one item, replace it with a default item.
      item = this.createDefaultableItem(this.defaultInsertType);
      selection = this.selectionInit(item);
      newItems = [item];
    }
    if (!this.replaceItems(index, 1, ...newItems)) {
      return;
    }
    this.props.requestSelection?.(selection);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _itemUpdateHelper(index: number, content: any) {
    const type = this.props.getType(this.atIndex(index));
    return reactUpdate(
      this.props.getRoot(),
      this.props.itemsAccessor(kv(index, this.props.setContent(type, content)))
    );
  },

  itemUpdateHandler(
    index: number,
    content: NotePart,
    selectors?: Optional<Array<Selector>>,
    tableOp?: TableOpDiffMap
  ) {
    this._clearPendingCuts();
    const root = this._itemUpdateHelper(index, content);
    const performTableEvaluation =
      this.requiresTableEvaluationOnUpdate == null ||
      this.requiresTableEvaluationOnUpdate(this.atIndex(index)) ||
      tableOp != null; // requiresTableEvaluationOnUpdate will eventually be replaced by edit ops
    this.props.updateRoot?.(root, {
      performTableEvaluation,
      updatedItemPartIndexes: [index],
      canIncrementalSave: !performTableEvaluation,
      multidocTableOp: tableOp != null ? {[this.props.fileId]: tableOp} : undefined,
    });
  },

  tableUpdateHandler(
    index: number,
    content: NotePart & {table: Table},
    selectors: Array<Selector> | null,
    tableOp?: TableOpDiffMap
  ) {
    this._clearPendingCuts();
    OnboardingActions.completeOnboardingTask(
      OnboardingConstants.MODULES.ENTRY,
      OnboardingConstants.CREATE_EDIT_TABLE
    );
    let root = this._itemUpdateHelper(index, content);
    if (selectors != null) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root = {...root, selectors} as any;
    }
    this.props.updateRoot(root, {
      multidocTableOp: tableOp != null ? {[this.props.fileId]: tableOp} : undefined,
    });
  },

  itemMouseOverHandler(index: number, e: React.MouseEvent) {
    this.multiEditableMouseOverHandler?.(index, e);
  },

  itemMouseMoveHandler(index: number, e: React.MouseEvent) {
    this.multiEditableMouseMoveHandler(index, e);
  },

  itemMouseDownHandler(index: number, e: React.MouseEvent) {
    const allowSingleOverride =
      $(e.target).closest('[data-mediocre-item-select]').attr('data-mediocre-item-select') === '1';
    const bufferedSelect =
      $(e.target)
        .closest('[data-mediocre-item-buffered-select]')
        .attr('data-mediocre-item-buffered-select') === '1';
    const isMultiExpandBuffered = this.isItemTextual(this.atIndex(index)) || bufferedSelect;
    this.multiEditableMouseDownHandler?.(
      {
        start: index,
        active: true,
        allowSingleOverride,
        isMultiExpandBuffered,
      },
      e
    );
  },

  textItemUpdateHandler(index: number, e: {selection?: BenchlingSelection; text?: string; formats?: Format}) {
    Perf.measure(this.typingPerfId);
    const {text, formats} = e;
    this.updateItemText(index, {text: text!, formats: formats ?? formatters.defaultFormats()});
    this.props.requestSelection?.({selection: e.selection || selutil.getSelectionIndices()!});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textItemMergeUpHandler(index: number, e: {anchor: any}) {
    const {anchor} = e;

    const item = this.atIndex(index);

    // Delete the indentation if there is one.
    if (item.indentation > 0 && !anchor) {
      const newItem = {...item, indentation: item.indentation - 1, listType: null};
      this.replaceItems(index, 1, newItem);
      return;
    }

    const mergeItems = (index2: number): void => {
      const aboveItem = this.atIndex(index2);
      const belowItem = this.atIndex(index2 + 1);

      const isAboveText = this.itemHasText(aboveItem);
      const isBelowText = this.isItemTextual(belowItem);

      let aboveFmtText;
      let belowFmtText;
      let text;
      if (isAboveText) {
        aboveFmtText = this.getText(aboveItem);
      }
      if (isBelowText) {
        belowFmtText = this.getText(belowItem);
      }

      if (isAboveText && isBelowText) {
        // Normal merge betwen two textual steps.
        // Merge formats at the end of the raw text, b/c point formats take up 0 space before rendering
        // Place cursor at the end of the rendered text, b/c point formats add extra text
        assert(aboveFmtText !== undefined, 'Expected aboveFmtText to be defined');
        assert(belowFmtText !== undefined, 'Expected belowFmtText to be defined');
        const mergePosition = aboveFmtText.text.length;
        const cursor = aboveItem.text.length;

        const formats = formatters.joinFormats(aboveFmtText.formats, belowFmtText.formats, mergePosition);
        text = aboveFmtText.text + belowFmtText.text;
        const newItem = this.withUpdatedText(aboveItem, {text, formats});
        if (!this.replaceItems(index2, 2, newItem)) {
          return;
        }
        const {start, end} = formatters.getSelectionIndicesFromFormatIndices(formats, cursor, cursor);
        this.props.requestSelection?.({selection: {cid: this.props.getCid(newItem), start, end}});
      } else if (isAboveText && !aboveFmtText?.text.length) {
        // Empty aboveItem, belowItem is non-text so selection goes to the beginning of belowItem.
        if (!this.replaceItems(index2, 1)) {
          return;
        }
        this.props.requestSelection?.(this.selectionAtStart(belowItem));
      } else if (!isAboveText && this.hasSelectionAll(aboveItem)) {
        // Above item does not have text to place the cursor at the end of, so select the whole item
        this.props.requestSelection?.(this.selectionAll(aboveItem));
      } else if (!isBelowText && this.hasSelectionAll(belowItem)) {
        // Below item does not have text to place the curser at the beginning of, so select the whole item
        this.props.requestSelection?.(this.selectionAll(belowItem));
      } else if (isBelowText && !belowFmtText?.text.length) {
        // Empty belowItem, aboveItem is non-text so selection goes to the end of aboveItem.
        if (!this.replaceItems(index2 + 1, 1)) {
          return;
        }
        this.props.requestSelection?.(this.selectionAtEnd(aboveItem));
      }
    };

    if (anchor) {
      // Merge with below, if possible.
      if (index + 1 < this.props.getItems(this.props.getRoot()).length) {
        mergeItems(index);
      }
    } else if (index - 1 >= 0) {
      // Merge with above, if possible.
      mergeItems(index - 1);
    }
  },

  pasteHandler(index: number, e: PasteEvent, fileAnalyticsParams: FileAnalyticsParams) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {before, selected, after, originalEvent} = e as any;
    const splitItem = this.atIndex(index);

    // Index lies after a chip if: # chips before index + length of text < cursor index
    const chipsBefore = formatters.splitFormats(
      splitItem.formats ?? formatters.defaultFormats(),
      before.length
    ).before.internalLink.length;
    const afterPoint = chipsBefore + before.length < selutil.getSelectionIndices()!.start;

    const beforeFormats = formatters.splitFormats(
      this.getText(splitItem).formats,
      before.length,
      afterPoint
    ).before;
    const afterFormats = formatters.splitFormats(
      this.getText(splitItem).formats,
      before.length + selected.length,
      afterPoint
    ).after;
    const type = this.props.getType(splitItem);
    const lastItem = reactUpdate(splitItem, this.setText(type, {text: before, formats: beforeFormats}));
    this.pasteRangeHandler(
      {
        start: index,
        end: index,
        replacement: lastItem,
        after: {text: after, formats: afterFormats},
        originalEvent,
      },
      fileAnalyticsParams
    );
  },

  formatRangeHandler(params: {
    start: number;
    end: number;
    format: keyof Format;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
  }) {
    const {start, end, format, data} = params;
    assert(start <= end, 'Expected end to be greater than start in format range');

    // Ignore formats that are not supported for multi-line selections
    if ([FormattersConstants.DAY, FormattersConstants.CYCLE_HEADER].includes(format)) {
      return;
    }

    const items = this.subList(start, end);
    const textualItems = items.filter((item: NotePart) => this.itemHasText(item));
    const oldFmtTexts = textualItems.map((item: NotePart) => this.getText(item));
    const newFmtTexts = formatters.formatTexts(oldFmtTexts, {format, data});
    const fmtTextMap: {[cid: string]: {text: string; formats: Format}} = _.object(
      textualItems.map((item: NotePart) => this.props.getCid(item)),
      newFmtTexts
    );

    const noteParts = items.map((item: NotePart) => {
      const fmtText = fmtTextMap[this.props.getCid(item)];
      if (fmtText != null) {
        return reactUpdate(item, this.setText(this.props.getType(item), fmtText));
      }
      return item;
    });
    this.replaceItems(start, end - start + 1, ...noteParts);
  },

  deleteRangeHandlerDefault(params: {start: number; end: number}) {
    const {start, end} = params;
    let item;
    let newItems: Array<NotePart>;
    let selection;
    if (start > 0) {
      // Deleting from the middle.
      item = this.atIndex(start - 1);
      selection = this.selectionAtEnd(item);
      newItems = [];
    } else if (this.lastIndex() > end) {
      // Deleting from the beginning, but not deleting everything.
      item = this.atIndex(end + 1);
      selection = this.selectionAtStart(item);
      newItems = [];
    } else {
      // Deleting everything. Since there has to be at least one item, replace it with a default item.
      item = this.createDefaultableItem(this.defaultInsertType);
      selection = this.selectionInit(item);
      newItems = [item];
    }
    if (!this.replaceItems(start, end - start + 1, ...newItems)) {
      return;
    }
    this.clearMultiSelect();
    this.props.requestSelection?.(selection);
  },

  inputRangeHandler(params: {start: number; end: number; text: string}) {
    const {start, end, text} = params;
    const isCut = text === '';

    if (isCut && BenchlingConfig.ELN_ENABLE_ATOMIC_CUT_PASTE) {
      const items = this.subList(start, end);
      const hasNonTextItem = items.some((item: NotePart) => {
        const type = this.props.getType(item);
        return type !== NoteConstants.TEXT && type !== NoteConstants.CODE;
      });

      if (hasNonTextItem) {
        this._setPendingCuts(buildPendingCutsFromItems(items, this.props.getCid));
        this.props.undoStoreState?.();
        return;
      }
    }

    const startItem = this.atIndex(start);
    const newType = this.isItemTextual(startItem) ? this.props.getType(startItem) : this.textType;
    const newItem = this.withUpdatedText(this.makeItem(newType), {
      text,
      formats: formatters.defaultFormats(),
    });
    if (this.replaceItems(start, end - start + 1, newItem)) {
      this.props.requestSelection?.(this.selectionAtEnd(newItem));
    }
  },

  async convertWyciwypPartsToItems(
    clipboardData: DataTransfer
  ): Promise<{items: Array<NotePart>; selectors: Array<Selector> | null}> {
    let maxDesiredIndentation = 0;
    const usedTableNames = this.props.usedTableNames();
    const items: Array<NotePart> = [];
    let lastItem: NotePart | null = null;

    const parts = wyciwyp.processClipboard(clipboardData, {
      allowTables: this.tableType != null,
      allowHeaders: this.headerType !== this.textType,
      // If we are next to an @-sign, paste as plain text to allow search
      parseHTML: !this.state.atSignState,
    });

    const setIndentation = (params: {indentation: number; listType?: string | null}): void => {
      const {indentation, listType} = params;
      assert(lastItem != null, 'lastItem should not be null');
      const item =
        typeof this.withUpdatedListStyle === 'function'
          ? this.withUpdatedListStyle(lastItem, {indentation, listType})
          : undefined;
      if (item != null) {
        lastItem = item;
      }
      items[items.length - 1] = lastItem;
    };

    const addPart = (part: WYCIWYPPart): void => {
      if (this.makeItemFromWyciwypPart != null) {
        ({item: lastItem} = this.makeItemFromWyciwypPart(part, usedTableNames));
      } else {
        const {text, formats, type} = part;
        switch (type) {
          case wyciwyp.TABLE: {
            const tableName = excess.util.uniqueTableName(usedTableNames);
            assert(typeof text !== 'string', 'Expected table text to be an object');
            usedTableNames.push(tableName);
            const tableText = {
              ...text,
              name: tableName,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              table: text.table.map((row: Array<any>, i: any) =>
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                row.map((cell: Cell<unknown> | PastedCell, j: any) => sanitizeCell(cell, {row: i, column: j}))
              ),
            };
            // FIXME(T2129): The abstraction is breaking here, in that we now are making an assumption
            // about how data is stored on the part model.
            lastItem = reactUpdate(
              this.makeItem(this.tableType),
              this.props.setContent(this.tableType, {table: tableText})
            );
            break;
          }
          case wyciwyp.HEADER:
            lastItem = this.withUpdatedText(this.makeItem(this.headerType), {
              text: text as string,
              formats,
            });
            break;
          case wyciwyp.DESC:
            lastItem = this.withUpdatedText(this.makeItem(this.descType), {text: text as string, formats});
            break;
          default:
            lastItem = this.withUpdatedText(this.makeItem(this.textType), {text: text as string, formats});
        }
      }
      items.push(lastItem);
    };

    if (parts.some((part) => part.listType != null && part.indentation === 0)) {
      logging.error('T6698: MediocreEditor.convertWyciwypPartsToItems generated bad indentation', {
        extra: {data: clipboardData.getData('text/html')},
      });
    }

    // This must be run before the below for loop, as we want the mutations to `parts` to be picked up by
    // addPart(part).
    const selectors = await resolveSelectorsFromPastedHTMLTables({
      pastedTables: parts
        .filter((part) => part.type === wyciwyp.TABLE)
        .map((part) => (part.text as Table).table),
      existingSelectors: this.getSelectors(),
      selectorsEnabled: true,
    });

    for (const part of parts) {
      const {indentation, listType} = part;
      addPart(part);
      if (indentation != null) {
        maxDesiredIndentation = Math.max(maxDesiredIndentation, indentation);
        const newIndentation = Math.max(Math.min(indentation, MAX_INDENTATION), 0);
        setIndentation({indentation: newIndentation, listType});
      }
    }

    if (maxDesiredIndentation > MAX_INDENTATION) {
      logging.info(`${MAX_INDENTATION} levels of indentation exceeded: ${maxDesiredIndentation}`);
    }

    return {items, selectors: selectors as Array<Selector>};
  },

  convertItemForPaste(
    itemParam: NotePart,
    destinationFileId: string,
    usedTableNames: Array<string> = [],
    usedTextBoxNames: Array<string> = [],
    isDestinationConfig?: boolean
  ) {
    // If the item is a table, ensure that it has a unique name.
    let name: string | null = null;
    let oldName = null;
    const isConfig =
      APIUtil.isEntryOrSubOrWorkflowTemplate(destinationFileId) ||
      (APIUtil.isDocument(destinationFileId) && isDestinationConfig);

    const plugin = this.getPluginByItem(itemParam);
    if (plugin.convertItemForPaste) {
      return plugin.convertItemForPaste.call(
        this,
        itemParam,
        destinationFileId,
        usedTableNames,
        usedTextBoxNames,
        isDestinationConfig
      );
    }

    // The following is a temporary hack as the code below that accesses item was written prior to proper typing.
    // We should refactor this code to use the proper typing.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let item = itemParam as any;
    // TODO(T10489): use getContent / setContent once DATA_TABLE and DATA_TABLE_CONFIG support spreadsheets.
    if (this.tableType != null && this.props.getType(item) === this.tableType) {
      // Plain tables
      ({name} = item.table);
      oldName = name;

      if (usedTableNames.includes(name!)) {
        name = excess.util.uniqueTableName(
          usedTableNames,
          excess.util.extractTableNamePrefix(item.table.name)
        );
        item.table.name = name;
      }
    } else if (this.props.getType(item) === ModelTypeConstants.DATA_TABLE && item.item != null) {
      // Data tables (legacy results)
      ({name} = item.item.config);
      oldName = name;
      if (usedTableNames.includes(name!)) {
        name = excess.util.uniqueTableName(
          usedTableNames,
          excess.util.extractTableNamePrefix(item.item.config.name)
        );
        item.item.config.name = name;
      }
    } else if (this.props.getType(item) === ModelTypeConstants.DATA_TABLE_CONFIG && item.item != null) {
      ({name} = item.item);
      oldName = name;
      if (usedTableNames.includes(name!)) {
        name = excess.util.uniqueTableName(
          usedTableNames,
          excess.util.extractTableNamePrefix(item.item.name)
        );
        item.item.name = name;
      }
      if (!isConfig) {
        const newItem = makeDefaultItem(NoteConstants.NOTE_LINKED_OBJECT);
        newItem.item = DataTableUtil.createDataTable(item.item);
        item = newItem;
      }
    } else if (
      [
        ModelTypeConstants.REGISTRATION_TABLE,
        ModelTypeConstants.REGISTRATION_TABLE_CONFIG,
        ModelTypeConstants.TRANSFER_TABLE,
        ModelTypeConstants.TRANSFER_TABLE_CONFIG,
      ].includes(this.props.getType(item) as ModelTypeConstants) &&
      item.item != null
    ) {
      // Remaining legacy tables
      ({name} = item.item);
      oldName = name;
      if (usedTableNames.includes(name!)) {
        name = excess.util.uniqueTableName(
          usedTableNames,
          excess.util.extractTableNamePrefix(item.item.name)
        );
        item.item.name = name;
      }
    } else if (this.props.getType(item) === NoteLinkedObjectType.STRUCTURED_TABLE) {
      // Structured tables
      oldName = item.item.name;
      ({item, name} = convertStructuredTableForPaste(item, {
        usedTableNames,
        destinationFileId,
        isDestinationConfig: isConfig,
        note: this.props.getRoot(),
      }));
    } else if (this.props.getType(item) === NoteLinkedObjectType.NOTE_LINKED_GROUP) {
      oldName = item.item.name;
      ({item, name} = convertNoteLinkedGroupForPaste(
        item,
        this,
        usedTableNames,
        destinationFileId,
        isConfig,
        this.props.getRoot()
      ));
    } else if (this.props.getType(item) === NoteConstants.NOTE_FILL_IN_TEXT_BOX) {
      oldName = item.item.name;
      if (usedTextBoxNames.includes(oldName)) {
        name = generateUniqueName(usedTextBoxNames, oldName, {
          allowNoSuffix: true,
          addSpaceAfterPrefix: true,
        });
      }
      // Text boxes need unique provenance ids
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      item = produce(item, (draftItem: {item: {provenanceUuid: string; name: any; cid: string}}) => {
        draftItem.item.provenanceUuid = uuidv4();
        draftItem.item.name = name || draftItem.item.name;
        draftItem.item.cid = _.uniqueId('note-fill-in-text-box');
      });
    } else if (this.props.getType(item) === NoteLinkedObjectType.NOTE_LINKED_ASSAY_DATA) {
      item = produce(item, (draftItem: {item: NoteLinkedAssayData}) => {
        draftItem.item = NoteLinkedAssayDataUtil.cloneNoteLinkedAssayData(item.item);
      });
    }

    return {addedItem: item, newName: name as string, oldName: oldName as string};
  },

  _augmentNoteParts(noteParts: Array<NotePart>) {
    const augmentNotePartsContext: AugmentNotePartsContext = {
      fileId: this.props.fileId,
      isProcedureMultibatchExecution:
        this.props.structuredTableInsertionContext?.isProcedureMultibatchExecution!,
    };
    return augmentNoteParts(noteParts, augmentNotePartsContext);
  },

  getTextBoxNames() {
    return this.props.getRoot
      ? this.props
          .getRoot()
          .noteParts?.filter(
            (notePart: NotePart) => isNotePartWithItem(notePart) && isNoteFillInTextBox(notePart.item)
          )
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .map((notePart: NotePart) => (notePart.item as any).name)
      : [];
  },

  // Bulk convert note parts for paste into a notebook
  // Tracks name collisions in order to update cross-table cell references
  convertItemsForPaste(
    items: Array<NotePart>,
    destinationFileId: string,
    usedTableNames: Array<string> = [],
    isDestinationConfig?: boolean
  ) {
    // rename items and collect table names to fix cross-table references
    const oldToNewName: {[oldName: string]: string} = {};
    const addedItems = [];
    const usedTextBoxNames = this.getTextBoxNames();
    for (const item of items) {
      // convert performs an in-place transformation
      const {addedItem, newName, oldName} = this.convertItemForPaste(
        item,
        destinationFileId,
        usedTableNames,
        usedTextBoxNames,
        isDestinationConfig
      );
      if (this.props.getType(item) === NoteConstants.NOTE_FILL_IN_TEXT_BOX) {
        usedTextBoxNames.push(newName);
      } else {
        usedTableNames.push(newName);
        oldToNewName[oldName] = newName;
      }
      addedItems.push(addedItem);
    }
    // Now each table formula must be updated to point to the correct table
    for (const item of addedItems) {
      if (this.tableType != null && this.props.getType(item) === this.tableType) {
        // Plain tables
        const table = item.table!.table;
        // Iterate through table and convert cross table references in cells
        for (const row of table) {
          for (const cell of row) {
            cell.text = FormulaUtil.updateCellReferencesForPaste(cell.text, oldToNewName);
          }
        }
      } else if (this.props.getType(item) === NoteLinkedObjectType.STRUCTURED_TABLE) {
        // Structured tables
        const structuredTable = item.item as AnyStructuredTable;
        // Convert cross table references in cells
        for (const row of structuredTable.rows) {
          for (const cell of row.cells) {
            const cellText = FormulaUtil.updateCellReferencesForPaste(cell.text, oldToNewName);
            cell.text = cellText;
          }
        }
        // Convert cross table references in column default values
        for (const col of structuredTable.columns) {
          const cellText = FormulaUtil.updateCellReferencesForPaste(col.defaultValue.text, oldToNewName);
          col.defaultValue.text = cellText;
        }
      } else if (item.item != null && this.props.getType(item) === ModelTypeConstants.DATA_TABLE_CONFIG) {
        // Data table configs
        // Legacy config tables only have a single "row" (which is really just the default values on the colums)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (const col of (item.item as any).columns) {
          const cellText = FormulaUtil.updateCellReferencesForPaste(col.defaultValue.text, oldToNewName);
          col.defaultValue.text = cellText;
        }
      }
    }
    return {items: addedItems, names: Object.values(oldToNewName)};
  },

  _buildAddedItemsForPaste(
    itemsToAdd: Array<NotePart>,
    replacement: NotePart | undefined,
    after?: {text: string; formats: Format}
  ): {addedItems: Array<NotePart>; selectedItem: NotePart | null; selection: MediocreSelection | null} {
    let lastItem: NotePart | null = replacement ?? null;
    const addedItems: Array<NotePart> = lastItem == null ? [] : [lastItem];

    const addText = (
      newText: string,
      newFormats: Format,
      param?: {
        isNewText?: boolean;
        newHeaderType?: string | null;
        newListType?: string | null;
        newIndentation?: number;
      } | null
    ): void => {
      if (param == null) {
        param = {};
      }
      const {newHeaderType, newListType, newIndentation, isNewText} = param;
      if (lastItem && lastItem.text === '') {
        // Potentially inherit styles from the item being merged in
        if (newHeaderType != null && this.canItemHaveHeader(lastItem)) {
          lastItem = reactUpdate(lastItem, this.headerTypeAccessor({$set: newHeaderType}));
        }
        if (newListType != null && newIndentation != null && this.withUpdatedListStyle != null) {
          lastItem = this.withUpdatedListStyle(lastItem, {
            indentation: newIndentation,
            listType: newListType,
          });
        }
      }
      let {text, formats} = this.getText(lastItem!);
      if (!isNewText || !formatters.isUnformatted(newFormats)) {
        // Follow the formatted text with the new formatted text
        formats = formatters.joinFormats(formats, newFormats, text.length);
        text += newText;
      } else {
        // Continue the formatting from the existing formatted text
        ({text, formats} = formatters.replaceText(formats, {before: text, selected: '', after: ''}, newText));
      }
      lastItem = this.withUpdatedText(lastItem!, {text, formats});
      addedItems[addedItems.length - 1] = lastItem;
    };

    let item;
    const baseItem = lastItem;
    for (let i = 0; i < itemsToAdd.length; i++) {
      // When i == 0, lastItem inherently has text, so paste only if item is just text
      item = itemsToAdd[i];
      const itemFormats = item.formats ?? formatters.defaultFormats();

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((baseItem?.item as any)?.type === NoteConstants.NOTE_FILL_IN_TEXT_BOX) {
        // Target notepart (textbox) should subsume the paste contents as text instead of inserting new notepart
        // Double check that the pasted item is text based
        if (!this.isItemTextual(item)) {
          notifications.warn('Destination does not support paste of non-text items', {
            id: 'textbox-non-text-paste',
            duration: 10,
          });
          continue;
        }
        // Insert pasted text, place new lines after noteparts except for the last one
        if (i === itemsToAdd.length - 1) {
          addText(item.text, itemFormats, {isNewText: true});
        } else {
          addText(`${item.text}\n`, itemFormats, {isNewText: true});
        }
        continue;
      } else if (i === 0 && lastItem != null && this.isItemTextual(item)) {
        // If the item we are appending to is also just text, we can set the indentation / bullet / header
        if (this.isItemTextual(lastItem)) {
          addText(item.text, itemFormats, {
            isNewText: true,
            newHeaderType: this.getHeaderType(item),
            newListType: typeof this.getListType === 'function' ? this.getListType(item) : undefined,
            newIndentation: typeof this.getIndentation === 'function' ? this.getIndentation(item) : undefined,
          });
          // If it is not just text (e.g. the caption of a table / image), it is very likely that the user is
          // pasting multiple lines of text after the object (e.g. pasting a list after a table). Since
          // captions do not support list type / indentation, we only add the text directly to the caption if
          // the user is pasting exactly one item. Otherwise, we just paste the items after the current item.
        } else if (itemsToAdd.length === 1) {
          addText(item.text, itemFormats, {isNewText: true});
        } else {
          // Indent the added item starting from the indentation of lastItem (the last item before the paste).
          item.indentation = this._getIndentationOfItemFromBase(baseItem, item);
          lastItem = item;
          addedItems.push(item);
        }
      } else {
        // Indent the added item starting from the indentation of baseItem (the last item before the paste).
        item.indentation = this._getIndentationOfItemFromBase(baseItem, item);
        lastItem = item;
        addedItems.push(item);
      }
    }

    // If the user pasted "abc" between two characters, e.g. "1|2", then the resulting document state
    // should be "1abc|2". Right now, we are at "1abc" and "2" is after. Now is the time to handle
    // cursor position, before we add the "2".
    const selectedItem = lastItem;

    // Assumption: If `this.itemHasText(selectedItem)` is true, then `this.selectionAtEnd(selectedItem)`
    // will return a selection that is only a function of `selectedItem`, so it is safe to call up front
    // before we append the "after" text.
    const selection: MediocreSelection | null =
      selectedItem && this.itemHasText(selectedItem) ? this.selectionAtEnd(selectedItem) : null;

    if (after != null && after.text.length) {
      if (lastItem && this.itemHasText(lastItem)) {
        addText(after.text, after.formats);
      } else {
        const afterItem = this.withUpdatedText(this.makeItem(this.textType), after);
        lastItem = afterItem;
        addedItems.push(afterItem);
      }
    }

    return {addedItems, selectedItem, selection};
  },

  // Replaces items from indices [start..end] with:
  //  1. replacement: an item (optional)
  //  2. items from parsing clipboardData (which may modify replacement)
  //  3. after: {text, formats} to append to the last added item
  pasteRangeHandler(params: PasteRangeParams, fileAnalyticsParams: FileAnalyticsParams) {
    this.saveMultiSelect?.();
    const {start, end, replacement, after, originalEvent} = params;

    if (this._shouldPerformAtomicMove(params)) {
      this._performAtomicMove(params);
      return;
    }

    this.parseItemsFromClipboard(originalEvent, fileAnalyticsParams)
      .then(({items: itemsToAdd, selectors: newSelectors}) => {
        // Note: Don't access originalEvent inside here, as the event call stack may be over.
        if (!this._isMounted) {
          return;
        }
        if (itemsToAdd == null || itemsToAdd.length === 0) {
          wyciwyp.warnForNoData(false);
          return;
        }

        const {
          addedItems: builtItems,
          selectedItem,
          selection,
        } = this._buildAddedItemsForPaste(itemsToAdd, replacement, after);

        this.props.storeState?.({selection: selutil.getSelectionIndices()!});
        if (newSelectors) {
          this.props.updateSelectors?.(newSelectors);
        }
        const addedItems = this._augmentNoteParts(builtItems);
        if (!this.replaceItems(start, end - start + 1, ...addedItems)) {
          return;
        }

        // Since this code is captured within a Promise, the state of the NoteEditor is flushed
        // with every call, which means that the changes performed in replaceItems are completed and
        // the selection code below will now search with an updated list of items.
        // If we didn't capture a text selection, we select the entire note part.
        const finalSelection: MediocreSelection | null = selection ?? this.selectionAtItem(selectedItem);
        if (finalSelection != null) {
          this.props.requestSelection?.(finalSelection);
        }
      })
      .catch((error: unknown) => {
        if (error instanceof StructuredTablePasteError) {
          this._clearPendingCuts();
          notifications.error(error.message);
          return;
        }
        throw error;
      });
  },

  _shouldPerformAtomicMove(params: PasteRangeParams): boolean {
    const pendingCuts = this.state?.pendingCuts ?? [];
    if (!BenchlingConfig.ELN_ENABLE_ATOMIC_CUT_PASTE || pendingCuts.length === 0) {
      return false;
    }

    // If clipboard data is coming from another file, fall through to a regular paste.
    const fileIds = extractFileIdsFromClipboard(params.originalEvent.clipboardData, this.editorName());
    const sameFilePaste =
      fileIds.length > 0 && fileIds.every((fileId) => fileId != null && fileId === this.props.fileId);
    if (!sameFilePaste) {
      this._clearPendingCuts();
      return false;
    }

    // Atomic move into a fill-in text box is not supported because you can only paste text there
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((params.replacement?.item as any)?.type === NoteConstants.NOTE_FILL_IN_TEXT_BOX) {
      this._clearPendingCuts();
      return false;
    }

    return true;
  },

  _performAtomicMove(params: PasteRangeParams): void {
    const {start, end, replacement, after, originalEvent} = params;
    const pendingCuts = this.state?.pendingCuts ?? [];

    // Check that clipboard data still matches pending cuts
    const clipboardMatchesPendingCuts = doesClipboardMatchPendingCuts(
      originalEvent.clipboardData,
      this.editorName(),
      pendingCuts
    );

    // Check that the NoteParts being removed match the pending cuts
    const noteParts = this.props.getItems(this.props.getRoot());
    const cutItems = findNotePartsForPendingCuts(noteParts, pendingCuts, this.props.getCid);

    // Show an error toast if there are data mismatches
    if (cutItems == null || !clipboardMatchesPendingCuts) {
      this._clearPendingCuts();
      notifications.error('Unable to paste cut content. Please cut again and retry');
      return;
    }

    // Define cut indices
    const cutStart = noteParts.findIndex((part: NotePart) => this.props.getCid(part) === pendingCuts[0].cid);
    const cutCount = pendingCuts.length;
    const cutEnd = cutStart + cutCount - 1;

    // Define paste indices
    const pasteStart = start;
    const pasteEnd = end;
    const pasteDeleteCount = end - start + 1;

    originalEvent.preventDefault();

    // If the cut and paste ranges overlap at all, no-op
    const rangesOverlap = pasteStart <= cutEnd && pasteEnd >= cutStart;
    if (rangesOverlap) {
      this._clearPendingCuts();
      this.props.undoStoreState?.();
      return;
    }
    this.props.storeState?.({selection: selutil.getSelectionIndices()!});

    const {addedItems, selection} = this._buildAddedItemsForPaste(
      cutItems.map((item: NotePart) => ({...item})),
      replacement,
      after
    );

    const atomicMoveSucceeded = this.replaceItemsForAtomicMove(
      cutStart,
      cutCount,
      pasteStart,
      pasteDeleteCount,
      addedItems
    );

    if (atomicMoveSucceeded) {
      if (selection) {
        this.props.requestSelection?.(selection);
      } else {
        const lastAddedItem = addedItems[addedItems.length - 1];
        this.props.requestSelection?.(this.selectionInit(lastAddedItem));
      }
    }
  },

  _getIndentationOfItemFromBase(baseItem: NotePart | null, newItem: NotePart | null) {
    const baseIndentation = baseItem?.indentation ?? 0;
    return newItem?.indentation == null
      ? baseIndentation
      : Math.min(baseIndentation + newItem.indentation, MAX_INDENTATION);
  },

  renderEditable(item: NotePart, index: number) {
    const type = this.props.getType(item);
    const plugin = this.getPluginByType(type);
    if (plugin == null) {
      throw new Error(`Unexpected plugin type: ${type}`);
    }
    const cid = this.props.getCid(item);
    const isItemPendingCut =
      this.state.pendingCuts.length > 0 &&
      isPendingCut(
        this.state.pendingCuts,
        cid,
        (item.item as {provenanceUuid?: string} | undefined)?.provenanceUuid
      );
    const editorProps = isItemPendingCut ? {...this.state.editorProps, locked: true} : this.state.editorProps;
    return (
      <MediocreItem
        key={cid}
        editor={this as MediocreItemEditor<NotePart>}
        index={index}
        item={item}
        isHighlighted={index === this.state.highlightIndex}
        selectedSubIndex={
          (this.state.selected != null ? this.state.selected.index : undefined) === index
            ? this.state.selected?.subIndex
            : undefined
        }
        isSelected={this.isSelected(index)}
        isBeforeInsert={index === this.state.insertIndex}
        editorProps={editorProps}
        itemProps={this.getItemProps(item, index)}
        {...getSearchResultPropsForIndex(this.state.searchState, cid)}
      />
    );
  },

  getRenderedItems(items: Array<NotePart>, indexSlice: IndexRange = DEFAULT_INDEX_SLICE) {
    const renderedItems = items
      .slice(indexSlice.start, indexSlice.end)
      .map((item: NotePart, i: number) => this.renderEditable(item, Math.max(indexSlice.start, 0) + i));
    return typeof this.postProcessRenderedItems === 'function'
      ? this.postProcessRenderedItems(indexSlice, renderedItems)
      : renderedItems;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setSearchState(searchState: any) {
    // For text-based plugins, `searchState` will ultimately render as HTML in an EditableComponent. When the
    // HTML is recreated, the browser selection is lost. To avoid this, we capture the current selection via
    // `setSelection`, which will be restored immediately after the next render, which is expected to happen
    // via the `setState` call that follows.
    this.setSelection?.(selutil.getSelectionIndices()!);
    this.setState({searchState});
  },

  /**
   * Indicate if the editor instance should virtualize contents.
   */
  isVirtualizationEnabled() {
    return this.isVirtualizationSupported() && !this.props.viewer;
  },

  setEditorRef(editor: HTMLDivElement | null) {
    const justMounted = editor != null && this.editor == null;
    const justUnmounted = editor == null && this.editor != null;
    if (justMounted || justUnmounted) {
      this.editor = editor;
    }
  },

  getEditorRef(): HTMLDivElement | null {
    return this.editor ?? null;
  },

  renderEditor(indexSlice: {start: number; end: number} | null | undefined) {
    if (indexSlice == null) {
      indexSlice = DEFAULT_INDEX_SLICE;
    }
    const docRoot = this.props.getRoot();
    const items = this.props.getItems(docRoot);
    const focusedItem = this.getFocusedItemOrNull();
    const pendingCuts = this.state.pendingCuts;
    return (
      <div
        className={classNames({
          editor: true,
          'show-placeholders': items.length === 1 && this.props.getType(items[0]) === this.textType,
        })}
        style={{position: 'relative'}}
        data-editor={this.props.editorKey}
        // create-react-class auto-binds methods, so this reference is already bound to the
        // component instance and is stable across renders; the unbound-method rule cannot see that.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref={this.setEditorRef}
        onKeyDown={(e) => {
          if (keyboard.isEscapeKey(e)) {
            this._clearPendingCuts();
          }
        }}
      >
        {this.renderFocusBearer?.()}
        {this.isVirtualizationEnabled?.() && (
          <CtrlFInput
            key="ctrl-f"
            docRoot={docRoot}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            editor={this as any}
            searchableItems={this.shouldRenderMaximizedTable?.() ? [] : this.getSearchableItems(docRoot)}
            focusedItem={focusedItem?.item}
            searchState={this.state.searchState}
            setSearchState={this.setSearchState}
            requestSelection={this.props.requestSelection}
          />
        )}
        <VirtualizedList
          documentType={APIUtil.apiIdToType(this.props.fileId)}
          documentVersionCid={this.getDocumentVersionCid()}
          isVirtualizationEnabled={this.isVirtualizationEnabled()}
        >
          {this.getRenderedItems(items, indexSlice)}
        </VirtualizedList>
        {pendingCuts.length > 0 && (
          <PendingCutOverlay
            pendingCuts={pendingCuts}
            editorRef={this.getEditorRef()}
            onCancel={this._clearPendingCuts}
          />
        )}
      </div>
    );
  },
};

interface ComponentWithSpec<P, S>
  extends Partial<React.Component<P, S>>, Partial<React.ComponentSpec<P, S>> {}

const Editor = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createClass<P, S, I extends ComponentWithSpec<P, S>>(options: Partial<I> & ThisType<I>) {
    _.defaults(options, {mixins: []});

    // Each mixin contributes part of the EditorMixinInterface contract to the assembled component,
    // and its methods run with `this` bound to the full interface. Typing the array here enforces
    // that every mixin literal is a valid partial implementation with a correct `this`, which is
    // what justifies the `ThisType<EditorMixinInterface>` annotations on the mixins themselves.
    const mixins: Array<Partial<EditorMixinInterface> & ThisType<EditorMixinInterface>> = [
      EditorMixin,
      EditableList,
      MultiSelectLinearList,
      EditorMultiEditableMixin,
    ];
    // The conformance check happens above at the typed `mixins` array; React's legacy `Mixin<P, S>`
    // spec type is looser, so cast here as we already do for the ComponentSpec on the return line.
    options.mixins?.push(...(mixins as Array<React.Mixin<P, S>>));
    const spec = options as ComponentWithSpec<P, S>;
    spec.registeredPlugins = {};
    for (const plugin of spec.plugins!) {
      spec.registeredPlugins![plugin.type] = plugin;
    }

    // oxlint-disable-next-line prefer-es6-class
    return createReactClass<P, S>(spec as React.ComponentSpec<P, S>);
  },
};

export default Editor;
